module.exports = __webpack_public_path__ + "img/project_2.dcc172b9.jpg";